var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { MenubarProgressBarState } from './MenubarProgressBarState';
import { MenubarProgressBarRemaining } from './MenubarProgressBarRemaining';
import { QuestionPassStateId } from '../../../../classes/learnware/LearnwareEnums';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let MenubarProgressBar = class MenubarProgressBar extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement("div", { style: {
                height: 20,
                flex: '0 1 auto',
                display: 'flex',
                flexDirection: 'row',
                marginTop: 10,
            } },
            React.createElement("div", { style: {
                    width: 50,
                    height: 3,
                    borderRadius: 3,
                    marginBottom: 3,
                    marginTop: 1,
                    float: 'left',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    background: 'linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%)',
                    backgroundRepeat: 'repeat-x',
                } }, app.topic.topicFilter.questionPassStates
                .concat()
                .sort(sortByFunc((s) => s.orderInProgressbar))
                .filter(s => s.id !== QuestionPassStateId.New)
                .map(questionstate => (React.createElement(MenubarProgressBarState, { app: app, questionstate: questionstate, key: questionstate.id })))),
            React.createElement("div", { style: { float: 'right', fontSize: 9, position: 'relative', top: -3, left: 4 } },
                React.createElement(AvailableTooltip, { placement: "left", title: "Anzahl verbleibender Fragen" },
                    React.createElement(MenubarProgressBarRemaining, { app: app })))));
    }
};
MenubarProgressBar = __decorate([
    observer
], MenubarProgressBar);
export { MenubarProgressBar };
